export default "__VITE_ASSET__yH2jfAVh__"